// ========================================================
// PRIMARY NAVIGATION
// - Classes to note:
//   - "is-hover" for hover events (mainly desktop)
//   - "is-active" for focus and click events (mainly mobile)
// ========================================================

// Document ready
$(() => {

	// ========================================================
	// INITIALIZE THE DESKTOP MEGA MENU - SUPERFISH
	// ========================================================

	$('.primary-nav .navbar__nav').superfish({
		popUpSelector: '.sf-mega',
		hoverClass: 'is-hover',
		delay: 500,
		onBeforeShow: function () {
			const $menu = $(this);
			const $image = $menu.find('.sf-mega__image img');

			// Lazy load initial image (do not run updateMenuImage() here)
			$image.attr('src', $image.data('src'));

			// Add class to body for a gradient background behind menu
			if ($menu.hasClass('sf-mega')) {
				$('body').addClass('menu-shown');
			}

			// Detect if we have grandchild pages and adjust the image height
			if ($menu.find('.sf-mega__menu-menu > li:first-child').hasClass('menu-item-has-children')) {
				$menu.find('.sf-mega__slot').addClass('has-active-menu');
			}
		},
		onBeforeHide: function () {
			if ($(this).hasClass('sf-mega')) {
				$('body').removeClass('menu-shown');
			}
		},
		onHide: function() {
			resetMegaMenu($(this));
		}
	});


	// ========================================================
	// UTILITY FUNCTIONS
	// ========================================================

	/**
	 * Update the menu image based on a dom element passed in.
	 * This is the tag with [data-image] set on it
	 *
	 * @param {object} domEl
	 * @param {string} event
	 */
	function updateMenuImage(domEl) {
		const $this = $(domEl);
		const $megaMenu = $this.parents('.sf-mega');
		const $imageSlot = $megaMenu.find('.sf-mega__slot .sf-mega__image');

		// Return early if no image is set
		if (!$this.data('image')) {
			return false;
		}

		const imageUrl = $this.data('image');
		const $curImage = $imageSlot.find('img');
		let preloaderImg = document.createElement("img");
		preloaderImg.src = imageUrl;
		preloaderImg.style.display = 'none';

		// Return early if images are the same
		if ($curImage.attr('src') === preloaderImg.src) {
			return;
		}

		// Fade out and remove old image
		$curImage.fadeOut(600, function() {
			$(this).remove();
		});

		// Listen for image load event
		preloaderImg.addEventListener('load', () => {
			$imageSlot.prepend(preloaderImg); // add in new image
			$imageSlot.find('img').fadeIn(300); // then fade it in
			preloaderImg = null;
		});

		// Update height of image slot (doing this last feels marginally more smooth /shrug?)
		if (!$this.parent().hasClass('panel-item')) {
			const menuItemHasChildren = $this.parent().hasClass('menu-item-has-children');
			$megaMenu.find('.sf-mega__slot').toggleClass('has-active-menu', menuItemHasChildren);
		}
	}

	/**
	 * Reset a mega menu back to its initial state.
	 *
	 * @param {object} $menu
	 */
	function resetMegaMenu($menu) {
		const $firstLi = $menu.find('.sf-mega__menu-menu > li:first-child');
		const firstLiHasChildren = $firstLi.hasClass('menu-item-has-children');

		// Remove .is-active class from any menu items
		$menu.find('.sf-mega__menu-menu > li').removeClass('is-active');
		// Activate first menu item
		$menu.find('.menu-item-has-children:first-child').addClass('is-active');
		// Update the menu image back to the first one
		updateMenuImage($firstLi.find('> a'));
		// Activate grandchild menu if first menu item has children
		$menu.find('.sf-mega__slot').toggleClass('has-active-menu', firstLiHasChildren);
		// Deactivate any shown grandchild menus
		$menu.find('.sf-mega__slot-menu .panel').removeClass('is-shown');
		// Activate correct granchild menu (if applicable)
		if (firstLiHasChildren) {
			$menu.find('.sf-mega__slot-menu').show().find('.panel:first-child').addClass('is-shown');
		}
		// Unhide menu image in case it's been hidden
		$menu.find('.sf-mega__image').show();
	}

	// ========================================================
	// 1ST LEVEL DROPDOWNS (CHILD PAGES)
	// ========================================================

	/**
	 * Trigger grandchild page menu panel
	 * - Trigger image change
	 * - Trigger 2nd level menu (slot menu) updates
	 */
	function triggerChildPage(e) {
		const $menuItem = $(e.currentTarget);
		const $anchor = $menuItem.find('> a');
		const targetID = $anchor.data('id');

		updateMenuImage($anchor[0]);

		$menuItem.addClass('is-active').siblings().removeClass('is-active');

		if ($menuItem.hasClass('menu-item-has-children')) {
			$menuItem.parents('.sf-mega').find('.sf-mega__slot-menu').show();
			$(`#panel-${targetID}`).addClass('is-shown').siblings().removeClass('is-shown');
			if ($(`#panel-${targetID}`).is('.panel:has(.panel-sub-menu)')) {
				$menuItem.parents('.sf-mega').find('.sf-mega__image').hide();
			} else {
				$menuItem.parents('.sf-mega').find('.sf-mega__image').show();
			}
		} else {
			$menuItem.parents('.sf-mega').find('.sf-mega__slot-menu').hide();
			$menuItem.parents('.sf-mega').find('.sf-mega__image').show();
		}
	}
	$('.sf-mega__menu > ul > li.menu-item').hoverIntent(e => triggerChildPage(e));
	$('.sf-mega__menu > ul > li.menu-item').on('focusin', e => triggerChildPage(e));

	/**
	 * KEYBOARD
	 * Child menu item focusout triggers grandchild menu activation.
	 */
	$('.sf-mega__menu > ul > li.menu-item-has-children a').on('focusout', e => {
		const targetID = $(e.currentTarget).data('id');

		e.stopPropagation();

		$(`#panel-${targetID} > li:first-child > a`).trigger('focus');
	});

	// ========================================================
	// 2ND LEVEL MENU INTERACTIONS (GRANDCHILD PAGES)
	// ========================================================

	/**
	 * Mouseenter event
	 * - Changes the menu image
	 */
	$('.sf-mega__slot-menu a').on({
		mouseenter: e => updateMenuImage(e.currentTarget)
	});

	/**
	 * KEYBOARD
	 * Last grandchild focusout resets focus back to child navigation
	 */
	$('.sf-mega__slot-menu li.menu-item:last-child a').on('focusout', e => {
		const $this = $(e.currentTarget);
		const id = $this.parents('.panel').attr('id').slice(6); // i.e. "panel-"
		const $parent = $this.parents('.sf-mega').find(`[data-id="${id}"]`).parent();

		e.stopPropagation();

		$parent.next('li.menu-item').find('a').trigger('focus');
	})


	// ========================================================
	// STICKY MENU (DESKTOP & MOBILE)
	// ========================================================

	/**
	 * Sticky menu
	 * - Desktop - becomes sticky after scrolling certain amount
	 * - Mobile - becomes sticky only when scrolling up
	 * - Self initializing function
	 */
	const initStickyMenu = (() => {
		const { $window, $document } = Globals;
		const $header = $('#header');
		const navbarHeight = $header.outerHeight();
		const isMobile = $window.width() < 992;

		let didScroll = false;
		let lastScrollTop = 0;

		// Mobile Header Slide In/Out - Hide and Show header on scroll down and up
		function hasScrolled() {
			let st = $window.scrollTop();

			// Make sure they scroll more than 5px
			if (Math.abs(lastScrollTop - st) <= 5) return;

			// Mobile sticky when scrolling up
			if (isMobile) {

				// If they scrolled down and are past the navbar, add class .nav-up.
				// This is necessary so you never see what is "behind" the navbar.
				if (st > lastScrollTop && st > navbarHeight) { // Scroll Down
					// Uncomment next line to hide navbar when scrolling down
					// $header.removeClass('shown top').addClass('hidden');

					// Comment out next line if above line is enabled
					$header.removeClass('top');
				} else if (st + $window.height() < $document.height()) { // Scroll Up
					$header.removeClass('hidden').addClass('shown');
					if (st <= 0) { // scrollTop will read less than 0 on mobile safari
						$header.addClass('top');
					}
				}

			// Desktop, sticky after certain distance
			} else {
				// Hide
				if (st < 800) {
					$header.removeClass('shown top').addClass('hidden');
					if (st <= 0) { // scrollTop will read less than 0 on mobile safari
						$header.addClass('top');
					}
				// Show
				} else {
					$header.removeClass('hidden top').addClass('shown');
				}
			}

			lastScrollTop = st;
		}

		$window.on('scroll', event => {
			didScroll = true;
		});

		setInterval(() => {
			if (didScroll) {
				hasScrolled();
				didScroll = false;
			}
		}, 250);

	})();

	// ========================================================
	// MOBILE MENU (FLYOUT PANELS)
	// ========================================================

	// Trigger menu open
	$('.navbar__toggler').on('click', () => {
		$('.site-header').toggleClass('mobile-menu-open');
		$('body').toggleClass('no-scroll');
	});

	// Trigger child and grandchild page flyouts
	$('li.menu-item').on('click', e => {
		$(e.currentTarget).addClass('is-active')
	});

	// Prevent clicks on actual menu links from triggering panel flyouts
	$('li.menu-item > a').on('click', e => {
		e.stopPropagation();
		e.stopImmediatePropagation();
	});

	// Trigger menu "back" functionality
	$('.sub-menu-header').on('click', e => {
		e.stopPropagation();
		$(e.currentTarget).closest('.is-active').removeClass('is-active');
	});

});
